import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { saveAs } from 'file-saver';
import * as webapi from 'apis/assegnoNucleoFamiliareApi';
import { Servizi, StatiRicerca } from 'enums';
import Snackbar, { SnackbarWrapper } from 'framework-ui-components/Components/Snackbar';
import debounce from 'framework-ui-components/Components/Utils/debouncer';
import AssegniNucleoFamiliare from './AssegniNucleoFamiliare';
import checkServizio from '../../helpers/checkServizio';
import ModaleCreazioneOrdinario from './ModaleCreazioneOrdinario';
import ModaleCreazioneVariazione from './ModaleCreazioneVariazione';
import ModaleCreazioneArretrato from './ModaleCreazioneArretrato';
import EventoServer from '../../libs/EventoServer';

class AssegnoNucleoFamiliareWrapper extends Component {
  state = {
    cont: 0,
    termine: '',
    stato: StatiRicerca.TUTTE,
    dichiarazioniSelezionate: [],
    contatoriStati: [],
  };

  constructor(props) {
    super(props);
    this.avviaStampa = this.avviaStampa.bind(this);
    this.apriDichiarazione = this.apriDichiarazione.bind(this);
    this.eliminaDichiarazione = this.eliminaDichiarazione.bind(this);
    this.duplicaDomandaANF = this.duplicaDomandaANF.bind(this);
    this.avviaCreazioneDichiarazioneOrdinaria = this.avviaCreazioneDichiarazioneOrdinaria.bind(this);
    this.avviaCreazioneDichiarazioneVariazione = this.avviaCreazioneDichiarazioneVariazione.bind(this);
    this.avviaCreazioneDichiarazioneArretrata = this.avviaCreazioneDichiarazioneArretrata.bind(this);
    this.aggiornaDichiarazioniSelezionate = this.aggiornaDichiarazioniSelezionate.bind(this);
    this.avviaImpostaStatoInLavorazione = this.avviaImpostaStatoInLavorazione.bind(this);
    this.avviaImpostaStatoCompleta = this.avviaImpostaStatoCompleta.bind(this);
    this.chiudiModaleCreazione = this.chiudiModaleCreazione.bind(this);
    this.creaDichiarazioneOrdinaria = this.creaDichiarazioneOrdinaria.bind(this);
    this.creaDichiarazioneVariazione = this.creaDichiarazioneVariazione.bind(this);
    this.modificaDichiarazioneVariazione = this.modificaDichiarazioneVariazione.bind(this);
    this.avviaTrasmissioneEPASA = this.avviaTrasmissioneEPASA.bind(this);
    this.ottieniDelegaPatronatoEPASA = this.ottieniDelegaPatronatoEPASA.bind(this);
    this.avviaRicerca = debounce(this.avviaRicerca.bind(this), 100);
    this.aggiornaRicerca = debounce(this.aggiornaRicerca.bind(this), 1000);

    const aaaa = new Date().getFullYear();
    const inizioCampagna = new Date(
      aaaa, // anno da data corrente
      window.config.dataInizioCampagnaANF.split('/')[1] - 1, // mese (da config)
      window.config.dataInizioCampagnaANF.split('/')[0], // giorno (da config)
    );
    if (new Date() < inizioCampagna) {
      this.state.annoCampagna = aaaa - 1;
    } else {
      this.state.annoCampagna = aaaa;
    }
  }

  componentWillMount() {
    EventoServer.subscribe('DichiarazioneCreata', this.aggiornaRicerca);
    EventoServer.subscribe('DichiarazioneEliminata', this.aggiornaRicerca);
    EventoServer.subscribe('DichiarazioneStatoModificato', this.aggiornaRicerca);
    EventoServer.subscribe('StampaDichiarazioneCompletata', this.aggiornaRicerca);
    EventoServer.subscribe('DichiarazioneModificaStatoFallita', this.notificaDichiarazioneCambioStatoFallito);
    EventoServer.subscribe('DichiarazioneStatoModificato', this.notificaDichiarazioneStatoModificato);
    EventoServer.subscribe('AssegnoNucleoFamiliareDuplicato', this.notificaDomandaDuplicata);
  }

  componentWillReceiveProps({ codiceUfficio }) {
    this.avviaRicerca({ codiceUfficio });
  }

  componentWillUnmount() {
    EventoServer.unsubscribe('DichiarazioneCreata', this.aggiornaRicerca);
    EventoServer.unsubscribe('DichiarazioneEliminata', this.aggiornaRicerca);
    EventoServer.unsubscribe('DichiarazioneStatoModificato', this.aggiornaRicerca);
    EventoServer.unsubscribe('StampaDichiarazioneCompletata', this.aggiornaRicerca);
    EventoServer.unsubscribe('DichiarazioneModificaStatoFallita', this.notificaDichiarazioneCambioStatoFallito);
    EventoServer.unsubscribe('DichiarazioneStatoModificato', this.notificaDichiarazioneStatoModificato);
    EventoServer.unsubscribe('AssegnoNucleoFamiliareDuplicato', this.notificaDomandaDuplicata);
  }

  componentDidMount() {
    const { codiceUfficio } = this.props;
    this.avviaRicerca({ codiceUfficio });
  }

  aggiornaStato(data = {}) {
    return new Promise((resolve) => this.setState(data, () => resolve(data)));
  }

  avviaCreazioneDichiarazioneOrdinaria(modaleCreazioneContext) {
    this.setState({ apriModaleCreazioneOrdinario: true, modaleCreazioneContext });
  }

  avviaCreazioneDichiarazioneVariazione(modaleCreazioneContext) {
    this.setState({ apriModaleCreazioneVariazione: true, modaleCreazioneContext });
  }

  avviaCreazioneDichiarazioneArretrata(modaleCreazioneContext) {
    this.setState({ apriModaleCreazioneArretrato: true, modaleCreazioneContext });
  }

  chiudiModaleCreazione() {
    this.setState({
      apriModaleCreazioneOrdinario: false,
      apriModaleCreazioneVariazione: false,
      apriModaleCreazioneArretrato: false,
    });
  }

  apriDichiarazione(id, modifica, duplicata) {
    window.location = this.urlAssegnoNucleoFamiliare(id, modifica, duplicata);
    // this.chiudiModaleCreazione();
  }

  creaDichiarazioneOrdinaria(richiedente) {
    const { codiceUfficio, annoCampagna } = this.state;
    return webapi.creaOrdinario({ anno: annoCampagna, codiceUfficio, ...richiedente });
  }

  creaDichiarazioneVariazione(richiedente) {
    const { codiceUfficio, annoCampagna } = this.state;
    return webapi
      .creaVariazione({ anno: annoCampagna, codiceUfficio, ...richiedente })
      .then(this.ensureSuccessResponse);
  }

  modificaDichiarazioneVariazione(idDichiarazione, dataInizio) {
    return webapi
      .modificaVariazione({ idDichiarazione, dataInizio })
      .then(this.ensureSuccessResponse);
  }

  eliminaDichiarazione(idDichiarazione) {
    return webapi
      .eliminaDichiarazione({ idDichiarazione })
      .then(this.ensureSuccessResponse)
      .catch((ex) => this.notificaErrore(ex));
  }

  duplicaDomandaANF(idDichiarazione, CodiceFiscale, CodiceUfficio, Tipo) {
    return webapi
      .duplicaDomandaANF({
        idDichiarazione, CodiceFiscale, CodiceUfficio, Tipo,
      })
      .then(this.ensureSuccessResponse)
      .catch((ex) => this.notificaErrore(ex));
  }

  aggiornaRicerca(evento) {
    if (evento.CurrentUserId == window.datiUtente.IdentificativoUtente) {
      this.avviaRicerca({ cont: this.state.cont + 1 });
    }
  }

  avviaRicerca(filtri) {
    this.aggiornaStato(filtri)
      .then(() => (filtri.codiceUfficio != null || filtri.termine != null || filtri.cont != null) && this.aggiornaStati(this.state))
      .then(() => this.aggiornaGriglia(this.state));
  }

  avviaStampa(idDichiarazioni) {
    return webapi
      .avviaStampa({ idDichiarazioni })
      .then(this.ensureSuccessResponse)
      .then((response) => SnackbarWrapper.startDeterminateAsyncTask(response.CorrelationId, 'Stampa PDF', idDichiarazioni.length))
      .catch((ex) => this.notificaErrore(ex));
  }

  avviaImpostaStatoInLavorazione(idDichiarazioni) {
    return webapi.avviaImpostaStatoInLavorazione({ idDichiarazioni })
      .then(this.ensureSuccessResponse)
      .then((response) => SnackbarWrapper.startDeterminateAsyncTask(response.CorrelationId, 'Cambio stato "In lavorazione"', idDichiarazioni.length))
      .catch((ex) => this.notificaErrore(ex));
  }

  avviaImpostaStatoCompleta(idDichiarazioni) {
    return webapi.avviaImpostaStatoCompleta({ idDichiarazioni })
      .then(this.ensureSuccessResponse)
      .then((response) => SnackbarWrapper.startDeterminateAsyncTask(response.CorrelationId, 'Cambio stato "Completa"', idDichiarazioni.length))
      .catch((ex) => this.notificaErrore(ex));
  }

  avviaTrasmissioneEPASA(idDichiarazioni) {
    return webapi.avviaTrasmissioneEPASA({ idDichiarazioni })
      .then(this.ensureSuccessResponse)
      .then((response) => SnackbarWrapper.startDeterminateAsyncTask(response.CorrelationId, 'Cambio stato "Trasmessa EPASA"', idDichiarazioni.length))
      .catch((ex) => this.notificaErrore(ex));
  }

  ottieniDelegaPatronatoEPASA(idDichiarazioni, dichiarante) {
    return webapi.ottieniDelegaPatronatoEPASA({ idDichiarazioni })
      .then(this.ensureSuccessResponse)
      .then((res) => {
        if (res.Success) {
          saveAs(
            `data:application/pdf;base64,${res.Response.Delega}`,
            `DELEGA ${dichiarante}.pdf`,
            {
              type: 'application/pdf',
            },
          );

          saveAs(
            `data:application/pdf;base64,${res.Response.Liberatoria}`,
            `LIBERATORIA ${dichiarante}.pdf`,
            {
              type: 'application/pdf',
            },
          );
          SnackbarWrapper.notifySuccess('Delega scaricata con successo.');
        }
      })
      .catch((ex) => this.notificaErrore(ex));
  }

  aggiornaGriglia({
    stato, termine, codiceUfficio, cont,
  }) {
    return this.setState({
      urlRicerca: `assegnonucleofamiliare/cerca?stato=${stato}&termine=${termine}&codiceufficio=${codiceUfficio}&cont=${cont}`,
    });
  }

  aggiornaDichiarazioniSelezionate(dichiarazioniSelezionate = []) {
    return this.setState({
      dichiarazioniSelezionate,
      azioniGruppoAttive: dichiarazioniSelezionate.length > 0,
    });
  }

  aggiornaStati(filtri) {
    return webapi
      .statiANF(filtri)
      .then((contatoriStati) => this.setState({ contatoriStati }));
  }

  urlAssegnoNucleoFamiliare(idDichiarazione, modifica = false, duplicata = false) {
    const url = window.config.urlAnf;
    const [id] = idDichiarazione.match(/\d+(\-[A-Z])?/);
    return `${url}/#/Frontespizio/${!modifica ? 'Visualizza/' : ''}${id}${duplicata ? '?duplicata=true' : ''}`;
  }

  ensureSuccessResponse(result = { DetectedProblems: [] }) {
    return new Promise((resolve, reject) => (result.Success ? resolve(result) : reject(new Error(result.DetectedProblems.shift()))));
  }

  notificaErrore(ex) {
    SnackbarWrapper.notifyError(ex.message);
    throw ex;
  }

  notificaDichiarazioneCambioStatoFallito = (evt) => {
    if (
      Snackbar.recuperaOperazioniMassive().find(
        (x) => x.id == evt.CorrelationId,
      )
    ) {
      SnackbarWrapper.notifyAsyncTaskError(
        evt.CorrelationId,
        'Cambio stato fallito',
        `${evt.Descrizione} ${evt.DetectedProblems.$values[0]}`,
      );
    } else {
      // this.props.stopLoadingApplication();
      // if (evt.IdDichiarazione.indexOf('AssegnoNucleoFamiliare') != -1) {
      //    evt.DetectedProblems.unshift('Cambio stato fallito. ');
      //    SnackbarWrapper.notifyError(evt.DetectedProblems);
      // } else
      if (evt.DetectedProblems) {
        SnackbarWrapper.notifyError(evt.DetectedProblems.$values);
      } else {
        const msg = `Cambio stato fallito per dichiarazione ${evt.Descrizione}`;
        SnackbarWrapper.notifyError(msg);
      }
    }
  };

  notificaDichiarazioneStatoModificato = (evt) => {
    if (
      Snackbar.recuperaOperazioniMassive().find(
        (x) => x.id == evt.CorrelationId,
      )
    ) {
      SnackbarWrapper.updateDeterminateAsyncTaskProgress(evt.CorrelationId, 1);
    } else {
      // this.props.stopLoadingApplication();
      if (evt.Descrizione != null) {
        const msg = `Dichiarazione per ${evt.Descrizione} impostata in stato ${StatoDichiarazione.stringify(
          evt.NuovoStato,
          evt.HaErrori,
        )}`;
        SnackbarWrapper.notifySuccess(msg);
      }
    }
  };

  notificaDomandaDuplicata = (evt) => {
    this.aggiornaStato({ working: false });
    this.apriDichiarazione(evt.IdDichiarazione, true, true);
  };

  render() {
    const {
      annoCampagna, apriModaleCreazioneOrdinario, apriModaleCreazioneVariazione, apriModaleCreazioneArretrato,
    } = this.state;
    return (
      <div className="assegni-nucleo-familiare">
        <AssegniNucleoFamiliare
          {...this.props}
          {...this.state}
          avviaRicerca={this.avviaRicerca}
          avviaStampa={this.avviaStampa}
          avviaImpostaStatoInLavorazione={this.avviaImpostaStatoInLavorazione}
          avviaImpostaStatoCompleta={this.avviaImpostaStatoCompleta}
          apriDichiarazione={this.apriDichiarazione}
          avviaCreazioneDichiarazioneOrdinaria={this.avviaCreazioneDichiarazioneOrdinaria}
          avviaCreazioneDichiarazioneVariazione={this.avviaCreazioneDichiarazioneVariazione}
          avviaCreazioneDichiarazioneArretrata={this.avviaCreazioneDichiarazioneArretrata}
          aggiornaDichiarazioniSelezionate={this.aggiornaDichiarazioniSelezionate}
          eliminaDichiarazione={this.eliminaDichiarazione}
          duplicaDomandaANF={this.duplicaDomandaANF}
          avviaTrasmissioneEPASA={this.avviaTrasmissioneEPASA}
          ottieniDelegaPatronatoEPASA={this.ottieniDelegaPatronatoEPASA}
          annoCampagna={annoCampagna}
        />
        {
          apriModaleCreazioneOrdinario
          && (
            <ModaleCreazioneOrdinario
              {...this.state}
              chiudi={this.chiudiModaleCreazione}
              creaDichiarazioneOrdinaria={this.creaDichiarazioneOrdinaria}
              avviaImpostaStatoInLavorazione={this.avviaImpostaStatoInLavorazione}
              apriDichiarazione={this.apriDichiarazione}
              annoCampagna={annoCampagna}
            />
          )
        }
        {
          apriModaleCreazioneVariazione
          && (
            <ModaleCreazioneVariazione
              {...this.state}
              chiudi={this.chiudiModaleCreazione}
              creaDichiarazioneVariazione={this.creaDichiarazioneVariazione}
              modificaDichiarazioneVariazione={this.modificaDichiarazioneVariazione}
              avviaImpostaStatoInLavorazione={this.avviaImpostaStatoInLavorazione}
              apriDichiarazione={this.apriDichiarazione}
              annoCampagna={annoCampagna}
            />
          )
        }
        {
          apriModaleCreazioneArretrato
          && (
            <ModaleCreazioneArretrato
              {...this.state}
              chiudi={this.chiudiModaleCreazione}
              creaDichiarazioneOrdinaria={this.creaDichiarazioneOrdinaria}
              avviaImpostaStatoInLavorazione={this.avviaImpostaStatoInLavorazione}
              apriDichiarazione={this.apriDichiarazione}
              annoCampagna={annoCampagna}
            />
          )
        }
      </div>
    );
  }
}

const mapStoreToProps = (store) => ({
  codiceUfficio: store.utente.ufficioSelezionato.CodiceUfficio,
});

export default checkServizio(Servizi.ANF)(connect(mapStoreToProps, null)(AssegnoNucleoFamiliareWrapper));
